var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsItem",on:{"click":_vm.toDetail}},[_c('span',{staticClass:"val elli"},[_vm._v(_vm._s(_vm.detail.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }